<template>
  <label for="colour" class="fw-500 mb-2">Colour</label>
  <FlexCol class="gap-4">
    <FlexRow class="gap-2">
      <FlexRow class="gap-2">
        <input
          type="hidden"
          class="color-picker"
          v-init-picker:[store.bgOne]
          v-model="store.bgOne"
          style="height: 4rem; width: 4rem"
        />
        <FlexCol class="bg-grey rounded px-2">
          <label class="text-body-secondary">Colour</label>
          <span>{{ store.bgOne }}</span>
        </FlexCol>
      </FlexRow>
      <FlexRow class="gap-2" v-if="store.isGradient">
        <input
          type="hidden"
          class="color-picker"
          v-init-picker:[store.bgTwo]
          v-model="store.bgTwo"
          style="height: 4rem; width: 4rem"
        />
        <FlexCol class="bg-grey rounded px-2">
          <label class="text-body-secondary">Colour</label>
          <span>{{ store.bgTwo }}</span>
        </FlexCol>
      </FlexRow>
    </FlexRow>
    <FlexRow class="gap-2">
      <FlexCol
        class="align-items-center position-relative"
        @click="store.isGradient = false"
      >
        <div
          class="bg-primary d-flex justify-content-center align-items-center rounded-circle position-absolute start-0"
          style="width: 1.5rem; height: 1.5rem"
          v-if="!store.isGradient"
        >
          <IconCheck class="text-white" width="1rem" />
        </div>
        <div
          class="rounded-5 border black-shadow border-black"
          :class="{ 'border-5': !store.isGradient }"
          style="width: 10rem; min-height: 16rem"
          :style="{
            background: store.bgOne,
          }"
        ></div>
        <label for="solidColor">Flat Colour</label>
      </FlexCol>
      <FlexCol
        class="align-items-center position-relative"
        @click="store.isGradient = true"
      >
        <div
          class="bg-primary d-flex justify-content-center align-items-center rounded-circle position-absolute start-0"
          style="width: 1.5rem; height: 1.5rem"
          v-if="store.isGradient"
        >
          <IconCheck class="text-white" width="1rem" />
        </div>
        <div
          class="gap-1 rounded-5 border black-shadow border-black"
          :class="{ 'border-5': store.isGradient }"
          style="width: 10rem; min-height: 16rem"
          :style="{
            background:
              store.gradientType === 'linear'
                ? `linear-gradient(${replaceSymbol(store.angle)}deg, ${
                    store.bgOne
                  }, ${store.bgTwo})`
                : `radial-gradient(circle, ${store.bgOne}, ${store.bgTwo})`,
          }"
        ></div>
        <label for="solidColor">Gradient Colour</label>
      </FlexCol>
    </FlexRow>
    <template v-if="store.isGradient">
      <FlexCol class="gap-2">
        <label for="store.gradientType" class="fw-500">Gradient Type</label>
        <FlexRow class="gap-2">
          <button
            class="btn btn-outline-light px-5"
            :class="{ 'border-black': store.gradientType === 'linear' }"
            @click="store.gradientType = 'linear'"
          >
            Linear
          </button>
          <button
            class="btn btn-outline-light px-5"
            :class="{ 'border-black': store.gradientType === 'radial' }"
            @click="store.gradientType = 'radial'"
          >
            Radial
          </button>
        </FlexRow>
      </FlexCol>
      <FlexCol class="gap-2" v-if="store.gradientType === 'linear'">
        <label for="Gradient Position" class="fw-500">Gradient Position</label>
        <FlexRow class="gap-2">
          <WheelSelector
            :angle="replaceSymbol(store.angle)"
            @update-angle="
              (value) => {
                store.angle = useNumericInput(replaceSymbol(value)) + '°';
              }
            "
          />
          <input
            v-model="store.angle"
            id="angle-input"
            type="text"
            class="form-control w-50"
            @input="
              store.angle = useNumericInput(replaceSymbol(store.angle)) + '°'
            "
          />
        </FlexRow>
      </FlexCol>
    </template>
  </FlexCol>
</template>
<script setup>
import FlexCol from "@/layout/FlexCol.vue";
import FlexRow from "@/layout/FlexRow.vue";
import WheelSelector from "@/pages/LoyaltyProgram/MemberPortal/SettingPage/WheelSelector.vue";
import IconCheck from "@/assets/icons/IconCheck.vue";
import {
  vInitPicker,
  replaceSymbol,
  useStampCardStore,
} from "@/stores/stampCard";
import { useNumericInput } from "@/constants/formValidator";

const store = useStampCardStore();
</script>
